import DATATABLE_TRANSLATIONS from "./datatable_translations";
export default class AttachmentsDataTable {
  constructor() {
    $(document).ready(function() {
      showAttachmentsTable();
    });

    $(document).on("turbo:render", function() {
      showAttachmentsTable();
    });

    function showAttachmentsTable() {
      $('#attachments-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#attachments-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "attachment_type"},
          {"data": "comment"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
